import { useFischer } from 'composables/fischerPlugin';

export const usePriceCurrency = () => {
  const fischer = useFischer();

  const formatPrice = (price: number, currency: string) =>
    new Intl.NumberFormat(fischer.siteLanguage(), {
      style: 'currency',
      currency,
      ...(price % 1 === 0
        ? {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          }
        : {}),
    }).format(price);

  return { formatPrice };
};
